// Pure helpers for alert destinations (kept free of UI imports for tests).
// destinations: [{ key, scope, contact_id?, client_ref?, kind: 'email'|'sms', value, label }]
export function destinationKey(row) {
  return `${row.scope}:${row.contact_id || row.client_ref || ""}:${row.kind}:${String(row.value || "").trim().toLowerCase()}`;
}

export function selectedRecipients(alerts, destinations) {
  const keys = new Set(alerts?.recipientKeys || []);
  return destinations.filter((row) => keys.has(row.key));
}
